export const RepeatableQcFieldChildName = 'repeatableQcFieldChildComponent';
